module.exports = __webpack_public_path__ + "img/codeImg.11bfe985.jpg";